import { Box, Button, Checkbox, FormControlLabel, Link, Typography, useTheme } from "@mui/material";
import { ConsentContext } from "../user-consent-management";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import React from "react";
export const YoutubeEmbed = ({ aspectRatio = "16 / 9", grantId = "youtube", id, posterImage, title, }) => {
    const { t } = useTranslation("c-user-consent-management");
    const theme = useTheme();
    const grant = React.useMemo(() => ({ id: grantId }), [grantId]);
    const { addGrant, hasGrant } = React.useContext(ConsentContext);
    const [grantYoutube, setGrantYoutube] = React.useState(false);
    const [unlocked, setUnlocked] = React.useState(false);
    const handleChange = (event) => {
        setGrantYoutube(event.target.checked);
    };
    React.useEffect(() => {
        const hasYoutubeGrant = hasGrant(grant);
        setUnlocked(hasYoutubeGrant);
    }, [grant, hasGrant]);
    const unlock = () => {
        grantYoutube ? addGrant(grant) : setUnlocked(true);
    };
    return (React.createElement(Box, { sx: { backgroundColor: theme.palette.primary.dark, p: 1, borderRadius: theme.shape.borderRadius } }, unlocked ? (React.createElement(Box, { sx: {
            aspectRatio,
            borderRadius: theme.shape.borderRadius,
            height: "auto",
            overflow: "hidden",
            position: "relative",
            width: "100%",
            iframe: {
                border: "none",
                left: "0",
                top: "0",
                height: "100%",
                width: "100%",
                position: "absolute",
            },
        } },
        React.createElement("iframe", { allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, height: "480", src: `https://www.youtube-nocookie.com/embed/${id}?showinfo=0&modestbranding=1&rel=0`, title: title, width: "853" }))) : (React.createElement(Box, { sx: {
            aspectRatio,
            borderRadius: theme.shape.borderRadius,
            height: "auto",
            position: "relative",
            width: "100%",
        } },
        React.createElement(Image, { alt: title, fill: true, placeholder: "blur", sizes: "30vw", src: posterImage, style: { objectFit: "cover", objectPosition: "center", opacity: 0.85 }, title: title }),
        React.createElement(Box, { sx: {
                alignItems: "center",
                background: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                pb: 3,
                position: "absolute",
                pt: 4,
                textAlign: "center",
                top: "50%",
                transform: "translateY(-50%)",
                width: "100%",
            } },
            React.createElement(Typography, { color: "primary", variant: "body1" },
                t("unlock-youtube-info", "Mit dem Laden des Videos akzeptierst du die Datenschutzerklärung von YouTube."),
                " ",
                React.createElement(Link, { href: "https://policies.google.com/privacy?hl=de", target: "_blank" }, t("read-more", "Mehr erfahren"))),
            React.createElement(Button, { onClick: unlock, size: "small", variant: "contained", sx: { mt: 3, mb: 1 } }, t("unlock-youtube-button", "Video laden")),
            React.createElement(FormControlLabel, { componentsProps: { typography: { color: "primary", variant: "caption" } }, control: React.createElement(Checkbox, { checked: grantYoutube, onChange: handleChange, size: "small" }), label: t("youtube-grant", "YouTube Videos immer laden"), sx: { alignItems: "center" } }))))));
};
//# sourceMappingURL=youtube-embed.js.map